import { JsonLoader } from './JsonLoader';
import { GameApi, rankObj } from './GameApi';
import { ErrorDialog } from './Dialog';
import { UtilFunc } from './UtilFunc';
import { DialogController } from './DialogController';

export interface SettingParam {
    game_id: number;
    host: string;
}
/**
 * エラーメッセージ用JSON
 */
interface ErrorMessage {
    code: number,
    message: string
}

export abstract class GameMain extends createjs.Container {

    protected stageWidth: number;
    protected stageHeight: number;
    backgroundShape: createjs.Shape;
    public static bgColor: string = "#000";

    public FPS: number = 16;

    protected canvasStage: createjs.Stage;
    protected dialogLayer: createjs.Container;
    protected contentsLayer: createjs.Container;
    static errorDialog: ErrorDialog;
    protected api: GameApi
    protected env: string;
    protected nextUrl: string;
    width: number;
    height: number;
    stage: createjs.Stage;
    protected setting: SettingParam;
    protected debug: boolean;

    static UnconnectedError: ErrorMessage = { code: 5000, message: "サーバに接続できません。\r通信状況の良いところでプレイしてください" };
    static UndefinedError: ErrorMessage = { code: 0, message: "原因不明のエラーが発生しました" };
    static bestScore: number = 0;
    static uuid: string = "";
    static nickname: string = "";
    static age: string = "";
    static hash: string = "";
    static rankingData: Array<rankObj> = [];
    static myRankData: rankObj;
    constructor(canvasId: string) {
        super();
        const canvas = <HTMLCanvasElement>document.getElementById(canvasId);
        this.width = canvas.width;
        this.height = canvas.height;
        this.canvasStage = new createjs.Stage(canvas);
        this.canvasStage.enableMouseOver();

        this.backgroundShape = new createjs.Shape();
        this.backgroundShape.graphics.beginFill(GameMain.bgColor).drawRect(0, 0, this.width, this.height);
        this.addChild(this.backgroundShape);

        this.contentsLayer = new createjs.Container();
        this.addChild(this.contentsLayer);

        this.dialogLayer = new createjs.Container();
        this.addChild(this.dialogLayer);

        DialogController.instance = new DialogController(this.width, this.height, 0.2);
        this.dialogLayer.addChild(DialogController.instance);

        GameMain.errorDialog = new ErrorDialog();
        DialogController.instance.push(GameMain.errorDialog);

        createjs.Ticker.framerate = this.FPS;
        createjs.Ticker.addEventListener("tick", this.canvasStage);
        createjs.MotionGuidePlugin.install();


        // DialogController.instance.showDialog(GameMain.errorDialog);     
        this.debug = UtilFunc.getUrlParameter("debug") ? true : false;


        (async () => {
            // クラスの初期化
            await this.initClass();
            // ローディングバーの用意

            // 各画面の作成
            await this.createContents(this.contentsLayer);

            // コンテンツの初期化
            await this.initContents();

            // ローディング画面の解除

        })();

        this.canvasStage.addChild(this);
    }

    /**
     * クラスの初期化
     * リソース読み込みなどもここ
     */
    protected abstract initClass(): Promise<void>;

    /**
     * コンテンツの作成
     *
     * @param parent
     */
    protected abstract createContents(parent: createjs.Container): Promise<void>;

    /**
     * 作成したコンテンツ等の初期化
     */
    protected abstract initContents(): Promise<void>;
    /**
     * エラーハンドリング
     * @param code
     * @param message
     */
    static errerHandler(code: number, message?: string) {

        switch (code) {
            case 2001:
            case 2002:
            case 4001:
            case 4002:
                GameMain.errorDialog.setMessage("ERROR[" + code + "]", message);
                break;
            case 5000:
                GameMain.errorDialog.setMessage("ERROR[" + GameMain.UnconnectedError.code + "]", this.UnconnectedError.message);
                break;
            default:
                if (!message) {
                    message = this.UndefinedError.message;
                }
                GameMain.errorDialog.setMessage("", message);
                break;
        }
        DialogController.instance.showDialog(GameMain.errorDialog);
    }
}
